import React from 'react';
import { Link } from 'react-router-dom';
import blogData from '../../data/blogs.json';
import './BlogListing.css';

const BlogListing = () => {
  const { blogs } = blogData;

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  // Function to slugify the blog title for the URL
  const slugify = (text) =>
    text
      .toLowerCase()
      .replace(/[^a-z0-9\s-]/g, '') // Remove non-alphanumeric characters
      .trim()
      .replace(/\s+/g, '-'); // Replace spaces with hyphens

  return (
    <div className="blog-listing-container">
      <div className="blog-listing-header">
        <div className="container mx-auto px-4 py-16">
          <h1 className="blog-listing-title mt-16">Our Blog</h1>
          <p className="blog-listing-subtitle">
            Discover insights, tips, and stories about coworking spaces, productivity, and modern work culture.
          </p>
        </div>
      </div>

      <div className="blog-listing-content">
        <div className="container mx-auto px-4 py-12">
          <div className="blog-grid">
            {blogs.map((blog) => (
              <div key={blog.id} className="blog-card">
                <div className="blog-card-image">
                  <img
                    src={blog.bannerImage}
                    alt={blog.title}
                    loading="lazy"
                  />
                  <div className="blog-card-overlay">
                    <Link
                      to={`/blog/${slugify(blog.title)}`}
                      className="read-more-btn"
                    >
                      Read More
                    </Link>
                  </div>
                </div>

                <div className="blog-card-content">
                  <div className="blog-meta">
                    <span className="blog-date">{formatDate(blog.publishDate)}</span>
                    <span className="blog-read-time">{blog.readTime}</span>
                  </div>

                  <h2 className="blog-card-title">
                    <Link to={`/blog/${slugify(blog.title)}`}>
                      {blog.title}
                    </Link>
                  </h2>

                  <p className="blog-card-preview">
                    {blog.preview}
                  </p>

                  <div className="blog-card-footer">
                    <div className="blog-author">
                      <span>By {blog.author}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogListing;
